module.exports = __webpack_public_path__ + "static/media/employee-office.1148f2f0.png";